var s = /* @__PURE__ */ (function(R) {
  return R[R.NONE = 0] = "NONE", R[R.ERROR = 1] = "ERROR", R[R.WARN = 2] = "WARN", R[R.LOG = 3] = "LOG", R[R.DEBUG = 4] = "DEBUG", R;
})({}), i = class {
  static level = s.ERROR;
  static debug(R, ...t) {
    this.level >= s.DEBUG && console.debug(`[DEBUG]: ${R}`, ...t);
  }
  static log(R, ...t) {
    this.level >= s.LOG && console.log(`[LOG]: ${R}`, ...t);
  }
  static warn(R, ...t) {
    this.level >= s.WARN && console.warn(`[WARN]: ${R}`, ...t);
  }
  static error(R, ...t) {
    this.level >= s.ERROR && console.error(`[ERROR]: ${R}`, ...t);
  }
};
export {
  i as n,
  s as t
};

//# sourceMappingURL=Logger-CmiOOsKC.js.map